document.addEventListener('DOMContentLoaded', function() {
  const swiperOptions = {
    loop: true,
    slidesPerView: 2.2,
    spaceBetween: 12,
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 16
      }
    },
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  };

  const sliders = document.querySelectorAll('.cru-slider');
  sliders.forEach(slider => {
    const sectionContainer = slider.closest('.section');
    const prevEl = sectionContainer.querySelector('.swiper-button-prev');
    const nextEl = sectionContainer.querySelector('.swiper-button-next');

    new Swiper(slider, {
      ...swiperOptions,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
    });
  });
});
